import { makeStyles } from 'tss-react/mui';

import { VERTICAL_SCROLL_STYLE } from 'themes/defaultMuiTheme';
import { SECONDARY_BLUE_2 } from 'utilities/colors';

export const useShareSlideGroupModalStyles = makeStyles()((theme) => ({
  modalPaper: {
    position: 'absolute',
    'z-index': 1000,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    overflowY: 'auto',
    width: 500,
    borderRadius: '10px',
    ...VERTICAL_SCROLL_STYLE,
  },
  modalHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '18px 24px',
    borderBottom: '1px solid #0000001A',
  },
  title: {
    fontWeight: 500,
    fontSize: 16,
  },
  closeIcon: {
    color: '#1C1B1F',
    padding: 0,
  },
  modalContent: {
    padding: '18px 24px',
  },
  buttonsContent: {
    display: 'flex',
    gap: 14,
  },
  shareButton: {
    fontWeight: 400,
    fontSize: 12,
    padding: '10px 30px',
  },
  copyButton: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    backgroundColor: '#5470FF1A',
    color: SECONDARY_BLUE_2,
    '&:hover': {
      backgroundColor: '#5470FF1A',
      color: SECONDARY_BLUE_2,
    },
  },
}));
